import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { SURVEYS_PATHS as TEAM_SURVEY_PATHS } from "~/team/constants/paths.constants";
import { ButtonLink } from "./ds/ButtonLink";

export function SurveyNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Can&apos;t find this survey</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            The survey you&apos;re looking for doesn't exist, or the link may be broken. Check your survey list for
            available surveys, or try reloading the page
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}

export function TeamSurveyNotFound() {
  return (
    <SurveyNotFound>
      <ButtonLink variant="default" to={TEAM_SURVEY_PATHS.root}>
        View Surveys
      </ButtonLink>
    </SurveyNotFound>
  );
}
